module.exports = __webpack_public_path__ + "01_glasses_brown.9726126e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/01_glasses_brown.png
// module id = LA9L
// module chunks = 0